<div class="sp-mb-48">
  <h4>Checkbox Example</h4>
  <label ui-checkbox [(ngModel)]="checked">Checkbox</label>
</div>

<div class="sp-mb-48">
  <h4>Checkbox Group Example</h4>
  <div>
    <label ui-checkbox [(ngModel)]="allChecked" (ngModelChange)="updateAllChecked()" [uiIndeterminate]="indeterminate"> Check all </label>
  </div>
  <br />
  <ui-checkbox-group [(ngModel)]="checkOptionsOne" (ngModelChange)="updateSingleChecked()"></ui-checkbox-group>
</div>
<div class="sp-mb-48">
  <h4>Usage of Wrapper</h4>
  <ui-checkbox-wrapper style="width: 100%" (checkboxWrapperOnChange)="selectValues($event)">
    <div ui-row>
      <div ui-col uiSpan="8"><label ui-checkbox uiValue="A" [ngModel]="true">A</label></div>
      <div ui-col uiSpan="8"><label ui-checkbox uiValue="B">B</label></div>
      <div ui-col uiSpan="8"><label ui-checkbox uiValue="C">C</label></div>
      <div ui-col uiSpan="8"><label ui-checkbox uiValue="D">D</label></div>
      <div ui-col uiSpan="8"><label ui-checkbox uiValue="E">E</label></div>
    </div>
  </ui-checkbox-wrapper>

  <div class="sp-mt-16">
    <h5>Selected Values</h5>
    <div>{{ selectedArray | json }}</div>
  </div>
</div>
